module.exports = __webpack_public_path__ + "img/telegram.07f26541.svg";